import { getCookie } from '@ice-web-app/shared-utils-ssr';

// Type Imports
import type { Settings } from '../contexts/settingsContext';
import type { SystemMode } from '../types';

// Config Imports
import themeConfig from '../../configs/themeConfig';

export const getSettingsFromCookie = (): Settings => {
  const cookieName = themeConfig.settingsCookieName;

  if (cookieName) {
    const cookieValue = getCookie(cookieName);
    return cookieValue ? (decodeURI(cookieValue) as Settings) : (JSON.parse('{}') as Settings);
  }
  return JSON.parse('{}') as Settings;
};

export const getMode = () => {
  const settingsCookie = getSettingsFromCookie();

  // Get mode from cookie or fallback to theme config
  const mode = settingsCookie.mode || themeConfig.mode;

  return mode;
};

export const getSystemMode = (): SystemMode => {
  const mode = getMode();

  const colorPrefCookie = (getCookie('colorPref') || 'light') as SystemMode;

  return (mode === 'system' ? colorPrefCookie : mode) || 'light';
};

export const getServerMode = () => {
  const mode = getMode();
  const systemMode = getSystemMode();

  return mode === 'system' ? systemMode : mode;
};

export const getSkin = () => {
  const settingsCookie = getSettingsFromCookie();

  return settingsCookie.skin || 'default';
};
